import { render, staticRenderFns } from "./brandEvaluation.vue?vue&type=template&id=074d16be&scoped=true"
import script from "./brandEvaluation.vue?vue&type=script&lang=js"
export * from "./brandEvaluation.vue?vue&type=script&lang=js"
import style0 from "./brandEvaluation.vue?vue&type=style&index=0&id=074d16be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d16be",
  null
  
)

export default component.exports